<div class="gym-home-slides">
    <owl-carousel-o [options]="gymHomeSlides">
        <ng-template carouselSlide>
            <div class="gym-main-banner bg-dark bg-1"></div>
        </ng-template>
        <ng-template carouselSlide>
            <div class="gym-main-banner bg-dark bg-2"></div>
        </ng-template>
        <ng-template carouselSlide>
            <div class="gym-main-banner bg-dark bg-3"></div>
        </ng-template>
        <ng-template carouselSlide>
            <div class="gym-main-banner bg-dark bg-4"></div>
        </ng-template>
    </owl-carousel-o>
</div>